"use client";

import clsx from "clsx";
import { useField } from "formik";

interface Props {
  children: React.ReactNode;
  helper?: React.ReactNode;
  id: string;
  label: string;
  name: string;
}

export default function Field({ children, helper, id, label, name }: Props) {
  const [, meta] = useField(name);

  return (
    <div className="auth-field">
      <label className="auth-field__label" htmlFor={id}>
        {label}
      </label>
      {helper}
      <div
        className={clsx("auth-field__input", {
          "auth-field__input_state_error": Boolean(meta.error),
        })}
      >
        {meta.error && (
          <span className="auth-field__message">{meta.error}</span>
        )}
        <div className="auth-field__input-row">{children}</div>
      </div>
    </div>
  );
}
